module.exports = __webpack_public_path__ + "static/img/gaozhongdili7.ecca68f1.jpg";